import styled, { css } from "styled-components";
import type { PanelVariantsType } from "./Panel";

// STYLES
const insurance = css<{ active?: boolean }>`
    display: none;
    flex-direction: column;
    row-gap: calc(var(--spacing-3) / 2);
    padding: calc(var(--spacing-3) / 2) var(--spacing-2) var(--spacing-3);
    background-color: var(--color-grey-1);
    border: 1px solid var(--color-grey-6);

    ${(props) =>
        props.active &&
        css`
            display: flex;
            border-bottom: 0;
        `};
`;

// COMPONENTS
export const Header = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;

    &:not(:empty) {
        padding-bottom: calc(var(--spacing-3) / 2);
        border-bottom: 1px solid var(--color-grey-4);
    }
`;

export const PanelVariants = {
    insurance,
    finance: insurance,
};

const PanelVariant = styled.div<{ variant: PanelVariantsType; active?: boolean }>`
    ${({ variant }) =>
        variant &&
        css`
            ${PanelVariants[variant]};
        `};
`;

export default PanelVariant;
